import { render, staticRenderFns } from "./MgrupoprioridadGrid.vue?vue&type=template&id=22ca3ffc"
import script from "./MgrupoprioridadGrid.vue?vue&type=script&lang=js"
export * from "./MgrupoprioridadGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports